import actionTypes from './actionTypes';

export const addFilter = (filter, value) => ({
    type: actionTypes.VALUE_PICKER_FILTER_SET,
    payload: { filter, value },
});

export const removeFilter = filter => ({
    type: actionTypes.VALUE_PICKER_FILTER_REMOVE,
    payload: { filter },
});

export const clearFilters = () => ({
    type: actionTypes.VALUE_PICKER_CLEAR_FILTERS,
});

export const updateValuePickerFilters = (filter, value) => (dispatch) => {
    if (value) {
        dispatch(addFilter(filter, value));
    } else {
        dispatch(removeFilter(filter));
    }
};
